import React, { useState, useEffect, useCallback, useRef } from 'react';
import { jsPDF as JsPdf } from 'jspdf';
import { saveAs } from 'file-saver-es';
import { Workbook } from 'exceljs';
import axios from 'axios';

import './athlete_list.scss';

import {
    DataGrid,
    Sorting, Selection, HeaderFilter, Scrolling, SearchPanel, Editing,
    Export, Column, Toolbar, Item, LoadPanel

} from 'devextreme-react/data-grid';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { useMsal } from "@azure/msal-react";
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';

import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridToXLSX } from 'devextreme/excel_exporter';


import { FormPopup, AthleteNewForm, AthletePanel } from '../../components';
import { AthleteStatus } from '../../components';

import { ATHLETE_STATUS_LIST, NATIONS, exportFormats } from '../../shared/constants';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { getApiToken } from '../../utils/authUtils.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { onExporting } from '../../utils/exporter';
import { checkPermission } from '../../permissions';


const filterStatusList = ['alle', ...ATHLETE_STATUS_LIST];
const IMPORT_DATE_FIELDS = ['dateOfBirth', 'medicalCertificate', 'entryDate', 'exitDate'];
const IMPORT_FIELDS = [
    'rowNumber', 'firstName', 'lastName', 'gender', 'dateOfBirth', 'dsvId',
    'medicalCertificate', 'entryDate', 'traininggroupId', 'clubId', 'license',
    'exitDate', 'status', 'nation1', 'nation2', 'nation3', 'gradeLevel'
];
const IMPORT_GENDERS = [
    { value: 'M', text: 'männlich' },
    { value: 'W', text: 'weiblich' },
    { value: 'X', text: 'divers' }
];
const REQUIRED_CLUB_ERROR = 'Verein ist erforderlich.';

const dateFromImport = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;
    const datePart = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (datePart) {
        return new Date(Number(datePart[1]), Number(datePart[2]) - 1, Number(datePart[3]));
    }
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

const dateToImport = (value) => {
    if (!value) return null;
    const date = value instanceof Date ? value : dateFromImport(value);
    if (!date || Number.isNaN(date.getTime())) return value;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T00:00:00+00:00`;
};

const cellNameRender = (cell) => (
  
        <div>{cell.data.lastname}, {cell.data.surname}</div>
      
);

const editCellStatusRender = () => (
    <SelectBox className='cell-info' dataSource={ATHLETE_STATUS_LIST} itemRender={AthleteStatus} fieldRender={fieldRender} />
);


const fieldRender = (text) => (
    <>
        <AthleteStatus text={text} />
        <TextBox readOnly />
    </>
);



const dropDownOptions = { width: 'auto' };



export const AthleteList = () => {
      const { instance, accounts } = useMsal();
    const [searchParams, setSearchParams] = useSearchParams();
    const [gridDataSource, setGridDataSource] = useState();
    const [dataSourceClub, setDataSourceClub] = useState();
    const [dataSourceImportClub, setDataSourceImportClub] = useState([]);
    const [dataSourceTrainingGroup, setDataSourceTrainingGroup] = useState();
    const [isPanelOpened, setPanelOpened] = useState(false);
    const [athleteId, setAthleteId] = useState();
    const [popupVisible, setPopupVisible] = useState(false);
    const [formDataDefaults, setFormDataDefaults] = useState({});
    const [importPopupVisible, setImportPopupVisible] = useState(false);
    const [importRows, setImportRows] = useState([]);
    const [isImportLoading, setIsImportLoading] = useState(false);
    const fileInputRef = useRef(null);
    const gridRef = useRef(null);
    const navigate = useNavigate();

    // Get filter parameters from URL
    const filterTraininggroupId = searchParams.get('traininggroupId');
    const filterGroupname = searchParams.get('groupname');

    let newAthleteData;

    useEffect(() => {
        getApiToken(instance, accounts).then(token => {
            // Determine initial filter based on URL parameters
            let initialFilter;
            if (filterTraininggroupId) {
                // When filtering by training group, also show only active athletes initially
                initialFilter = [
                    ['traininggroupId', '=', filterTraininggroupId],
                    'and',
                    ['status', '=', filterStatusList[1]]
                ];
            } else {
                initialFilter = ['status', '=', filterStatusList[1]];
            }

            setGridDataSource({
                store: createStore({
                    key: 'athleteId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/Athletes`,
                    insertUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/InsertAthlete`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/UpdateAthlete`,
                    deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/DeleteAthlete`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                }), filter: initialFilter
            });
            const dataSource_club = createStore({
                key: 'clubId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Club/ClubsBasic`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });

            const importClubStore = createStore({
                key: 'clubId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Club/Clubs`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });

            const dataSource_traininggroup = createStore({
                key: 'traininggroupId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Traininggroup/TraininggroupsBasic`,

                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });

            dataSource_club.load().done(function (data) {
                setDataSourceClub(data);
            })
            importClubStore.load({ filter: ['activ', '=', true] }).then(data => {
                setDataSourceImportClub(data);
            }).catch(error => {
                console.error('Fehler beim Laden der aktiven Vereine für den Import:', error);
                notify({
                    message: 'Aktive Vereine konnten für den Sportlerimport nicht geladen werden',
                    position: { at: 'bottom center', my: 'bottom center' }
                }, 'error');
            });
            dataSource_traininggroup.load().done(function (data) {
                setDataSourceTrainingGroup(data);
            })
        });

    }, [filterTraininggroupId]);

    const changePopupVisibility = useCallback((isVisble) => {
        setPopupVisible(isVisble);
    }, []);

    const changePanelOpened = useCallback(() => {

        setPanelOpened(!isPanelOpened);
        gridRef.current?.instance().option('focusedRowIndex', -1);
    }, [isPanelOpened]);

    const changePanelPinned = useCallback(() => {
        gridRef.current?.instance().updateDimensions();
    }, []);

    const onAddAthleteClick = useCallback(() => {
        setPopupVisible(true);
    }, []);

    const onRowClick = useCallback(({ data }) => {
        // setAthleteId(data.athleteId);
        // setPanelOpened(true);
        const athleteId = data.athleteId;
        navigate(`/athlete/edit/${athleteId}`);
    }, []);

    const [status, setStatus] = useState(filterStatusList[1]); // Always start with "aktiv" status

    const filterByStatus = useCallback((e) => {
        const { item: status } = e;
        if (status === 'alle') {
            if (filterTraininggroupId) {
                gridRef.current?.instance().filter(['traininggroupId', '=', filterTraininggroupId]);
            } else {
                gridRef.current?.instance().clearFilter();
            }
        } else {
            if (filterTraininggroupId) {
                gridRef.current?.instance().filter([
                    ['status', '=', status],
                    'and',
                    ['traininggroupId', '=', filterTraininggroupId]
                ]);
            } else {
                gridRef.current?.instance().filter(['status', '=', status]);
            }
        }

        setStatus(status);
    }, [filterTraininggroupId]);

    const clearTraininggroupFilter = useCallback(() => {
        // Remove URL parameters and navigate to clean athlete list
        navigate('/athlete/list');
    }, [navigate]);

    const refresh = useCallback(() => {
        gridRef.current?.instance().refresh();
    }, []);

    const chooseImportFile = useCallback(() => {
        if (!checkPermission('athlete.add')) return;
        fileInputRef.current?.click();
    }, []);

    const onImportFileSelected = useCallback(async (event) => {
        const file = event.target.files?.[0];
        event.target.value = '';
        if (!file) return;

        const extension = file.name.split('.').pop()?.toLowerCase();
        if (!['csv', 'xlsx', 'xlsm'].includes(extension)) {
            notify({
                message: 'Bitte wählen Sie eine CSV- oder Excel-Datei (.xlsx, .xlsm) aus',
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'error');
            return;
        }
        if (file.size > 10 * 1024 * 1024) {
            notify({
                message: 'Die Datei darf maximal 10 MB groß sein',
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'error');
            return;
        }

        setIsImportLoading(true);
        try {
            const token = await getApiToken(instance, accounts);
            const formData = new FormData();
            formData.append('file', file);
            const response = await axios.post(
                `${process.env.REACT_APP_serverEndpoint}/Athlete/PreviewImportAthletes`,
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const rows = (response.data.rows || []).map(row => ({
                ...row,
                ...Object.fromEntries(IMPORT_DATE_FIELDS.map(field => [field, dateFromImport(row[field])])),
                errors: row.errors || []
            }));
            if (rows.length > 2000) {
                throw new Error('Die Vorschau enthält mehr als 2.000 Sportler.');
            }
            setImportRows(rows);
            setImportPopupVisible(true);
        } catch (error) {
            console.error('Fehler beim Einlesen der Sportlerdatei:', error);
            notify({
                message: error.response?.data?.detail || error.response?.data?.title || error.message || 'Die Datei konnte nicht eingelesen werden',
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'error');
        } finally {
            setIsImportLoading(false);
        }
    }, [instance, accounts]);

    const onImportRowUpdated = useCallback((event) => {
        setImportRows(rows => rows.map(row => row.rowNumber === event.key
            ? { ...row, ...event.data }
            : row));
    }, []);

    const submitImport = useCallback(async () => {
        if (!checkPermission('athlete.add') || importRows.length === 0) return;

        const rowsWithoutClub = importRows.filter(row => !row.clubId);
        if (rowsWithoutClub.length) {
            setImportRows(rows => rows.map(row => ({
                ...row,
                errors: row.clubId
                    ? (row.errors || []).filter(error => error !== REQUIRED_CLUB_ERROR)
                    : [...(row.errors || []).filter(error => error !== REQUIRED_CLUB_ERROR), REQUIRED_CLUB_ERROR]
            })));
            notify({
                message: 'Bitte wählen Sie für jede Zeile einen Verein aus',
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'error');
            return;
        }

        setIsImportLoading(true);
        try {
            const token = await getApiToken(instance, accounts);
            const rows = importRows.map(row => Object.fromEntries(
                IMPORT_FIELDS.map(field => [
                    field,
                    IMPORT_DATE_FIELDS.includes(field) ? dateToImport(row[field]) : (row[field] ?? null)
                ])
            ));
            const response = await axios.post(
                `${process.env.REACT_APP_serverEndpoint}/Athlete/ImportAthletes`,
                { rows },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const result = response.data;
            if (result.errors?.length) {
                setImportRows(currentRows => currentRows.map(row => {
                    const rowErrors = result.errors
                        .filter(error => error.rowNumber === row.rowNumber)
                        .map(error => error.message);
                    return rowErrors.length ? { ...row, errors: rowErrors } : row;
                }));
                notify({
                    message: 'Der Import wurde abgelehnt. Bitte prüfen Sie die markierten Zeilen.',
                    position: { at: 'bottom center', my: 'bottom center' }
                }, 'error');
                return;
            }

            notify({
                message: `${result.createdCount} Sportler erfolgreich importiert`,
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'success');
            setImportPopupVisible(false);
            setImportRows([]);
            refresh();
        } catch (error) {
            console.error('Fehler beim Importieren der Sportler:', error);
            const serverErrors = error.response?.data?.errors;
            if (Array.isArray(serverErrors) && serverErrors.length) {
                setImportRows(currentRows => currentRows.map(row => {
                    const rowErrors = serverErrors
                        .filter(item => item.rowNumber === row.rowNumber)
                        .map(item => item.message);
                    return rowErrors.length ? { ...row, errors: rowErrors } : row;
                }));
            }
            notify({
                message: error.response?.data?.detail || error.response?.data?.title || error.message || 'Der Import ist fehlgeschlagen',
                position: { at: 'bottom center', my: 'bottom center' }
            }, 'error');
        } finally {
            setIsImportLoading(false);
        }
    }, [accounts, importRows, instance, refresh]);

    const onDataChanged = useCallback((data) => {
        newAthleteData = data;
    }, []);

    const onSaveClick = useCallback(() => {
        getApiToken(instance, accounts).then(token => {  
            const datastore = createStore({
            key: 'athleteId',
            insertUrl: `${process.env.REACT_APP_serverEndpoint}/Athlete/InsertAthlete`,    
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    'Authorization': "Bearer " + token
                };
            },
        });
       
        datastore.insert(newAthleteData).then((data) => {

            notify({
                message: `Neuer Sportler "${data.surname} ${data.lastname}" gespeichert`,
                position: { at: 'bottom center', my: 'bottom center' }
            }
                ,
                'success'
            );
            setFormDataDefaults({ ...formDataDefaults });
            setPopupVisible(false);
            refresh();
        }).catch((error) => {
            notify({
                message: `Fehler beim Speichern des neuen Sportlers "${newAthleteData.surname} ${newAthleteData.lastname}"`,
                position: { at: 'bottom center', my: 'bottom center' }
            },
                'error'
            );
        });
    });
    }, []);

    return (
        <div className='view athlete-list'>
            <div className='view-wrapper view-wrapper-athlete-list list-page'>
                <DataGrid
                    className='grid theme-dependent'
                    noDataText=''
                    focusedRowEnabled
                    height='100%'
                    dataSource={gridDataSource}
                    onRowClick={onRowClick}
                    onExporting={onExporting}
                    allowColumnReordering
                    showBorders
                    ref={gridRef}
                    remoteOperations={true}
                >
                    <LoadPanel showPane={false} />
                    <SearchPanel visible placeholder='Sportler suchen' />
                    <Export enabled allowExportSelectedData formats={exportFormats} />
                    <Selection
                        selectAllMode='allPages'
                        showCheckBoxesMode='always'
                        mode='multiple'
                    />
                    <HeaderFilter visible />
                    <Sorting mode='multiple' />
                    <Scrolling mode='virtual' />
                    <Toolbar>
                        <Item location='before'>
                            <div className='grid-header'>
                                {filterGroupname ? `Sportler - ${filterGroupname}` : 'Sportler'}
                            </div>
                        </Item>
                        {filterTraininggroupId && (
                            <Item location='before' locateInMenu='auto'>
                                <Button
                                    icon='remove'
                                    text='TG-Filter entfernen'
                                    stylingMode='text'
                                    onClick={clearTraininggroupFilter}
                                />
                            </Item>
                        )}
                        <Item location='before' locateInMenu='auto'>
                            <DropDownButton
                                items={filterStatusList}
                                stylingMode='text'
                                text={status}
                                dropDownOptions={dropDownOptions}
                                useSelectMode
                                onSelectionChanged={filterByStatus}
                            />
                        </Item>
                        <Item location='after' locateInMenu='auto'>
                            {checkPermission('athlete.add') && (
                                <Button
                                    icon='upload'
                                    text='Sportler importieren'
                                    stylingMode='text'
                                    onClick={chooseImportFile}
                                    disabled={isImportLoading}
                                />
                            )}
                            <input
                                ref={fileInputRef}
                                type='file'
                                accept='.csv,.xlsx,.xlsm'
                                onChange={onImportFileSelected}
                                hidden
                            />
                            <Button
                                icon='plus'
                                text='Neuer Sportler'
                                type='default'
                                stylingMode='contained'
                                onClick={onAddAthleteClick}
                            />
                        </Item>
                        <Item
                            location='after'
                            locateInMenu='auto'
                            showText='inMenu'
                            widget='dxButton'
                        >
                            <Button
                                icon='refresh'
                                text='Refresh'
                                stylingMode='text'
                                onClick={refresh}
                            />
                              <Button
                                icon='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZmlsbD0iIzAwMDAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJtMjY4LjA3OCAzODcuNzI4bC4zOTMuM2wuMTE1LjA4N3phODUuNyA4NS43IDAgMCAwIDEyLjYgOC4wMjhhODUgODUgMCAwIDAgNC44MjQgMi4zMTlsLjA1OC4wMjVsLjE0NS4wNjRhODUgODUgMCAwIDAgMTYuNDc3IDUuMzA3YTg1IDg1IDAgMCAwIDUuMTcuOTMyTDI4MS4yOSA0NjUuOGwtMzkuMjc0LTE2LjY3MXptMTAzLjg0Ni0uMDA0bDI2LjA2MyA2MS40MDJsLTM5LjI3NSAxNi42NzJsLTI2LjA2LTYxLjM5NmE4NSA4NSAwIDAgMCAxMS43OTYtMi42MjNhODQuNyA4NC43IDAgMCAwIDE3LjE2LTcuMjZhODUgODUgMCAwIDAgNC4zMDgtMi41NzlsLjE0Ny0uMDk0bC4wNzMtLjA0N2E4NSA4NSAwIDAgMCA1LjQ0My0zLjgxMXpNMzE5Ljk5NiAyNTZDMzU1LjM1IDI1NiAzODQgMjg0LjY1MiAzODQgMzE5Ljk5OWMwIDM1LjM1LTI4LjY1MSA2NC4wMDEtNjQuMDA0IDY0LjAwMUMyODQuNjUgMzg0IDI1NiAzNTUuMzQ4IDI1NiAzMTkuOTk5QzI1NiAyODQuNjUyIDI4NC42NDkgMjU2IDMxOS45OTYgMjU2TTQ0OCA2NHYyOTguNjY3aC01NC4wODFhODUgODUgMCAwIDAgNi4xMDItMTIuOTYxYTg0LjcgODQuNyAwIDAgMCA0Ljg4Ni0yMS4xMjNsLjAyLS4yMDNsLjAxNS0uMTUzYTg2IDg2IDAgMCAwIC4zOTEtOC4yMjlWMTA2LjY2N0gxMDYuNjY3VjMyMGgxMjcuOTk5bC4wMTIgMS40MWE4NyA4NyAwIDAgMCAuNTUgOC40MzdhODUgODUgMCAwIDAgMi4yMzcgMTEuOTA5YTg0IDg0IDAgMCAwIDIuMDEyIDYuNTYyYTg1IDg1IDAgMCAwIDEuMjg2IDMuNDJsLjEuMjQ4bC4wNDguMTE5YTg1IDg1IDAgMCAwIDUuMTcgMTAuNTYxSDY0VjY0ek0zMTkuOTk5IDI5OC42NjdjLTExLjc4MyAwLTIxLjMzMiA5LjU1LTIxLjMzMiAyMS4zMzNzOS41NSAyMS4zMzMgMjEuMzMyIDIxLjMzM2MxMS43ODQgMCAyMS4zMzQtOS41NSAyMS4zMzQtMjEuMzMzcy05LjU1LTIxLjMzMy0yMS4zMzQtMjEuMzMzTTE0OS4zMzMgMTQ5LjMzM2gyMTMuMzM0VjE5MkgxNDkuMzMzem0wIDg1LjMzNGg4NS4zMzR2NDIuNjY2aC04NS4zMzR6IiBvcGFjaXR5PSIuODUiLz48L3N2Zz4='
                                text='Lizenzen'
                                stylingMode='text'
                                onClick={() => navigate('/athlete/license-update')  }
                            />
                              <Button
                                icon='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiB2aWV3Qm94PSIwIDAgNTAgNTAiIGZpbGw9IiMwMDAwMDAiPjxwYXRoIGZpbGw9IiMwMDAwMDAiIGQ9Ik00Mi45MjQgMTNIMzhWNy43NzRDMzggNC4wMzggMzUuMDUyIDEgMzEuMzA2IDFIMTguNjk1QzE0Ljk0NyAxIDEyIDQuMDM4IDEyIDcuNzc0VjEzSDcuMDc1QzMuNzE5IDEzIDEgMTUuNTkxIDEgMTguOTM3djIzLjAwN0MxIDQ1LjI4OSAzLjcxOSA0OCA3LjA3NSA0OGgzNS44NDlDNDYuMjc5IDQ4IDQ5IDQ1LjI4OSA0OSA0MS45NDNWMTguOTM3QzQ5IDE1LjU5MSA0Ni4yNzkgMTMgNDIuOTI0IDEzek0xNiA3Ljc3NEMxNiA2LjM3NSAxNy4yOTIgNSAxOC42OTUgNWgxMi42MTFDMzIuNzA1IDUgMzQgNi4zNzUgMzQgNy43NzRWMTNIMTZWNy43NzR6TTM2IDM1aC03djdoLTh2LTdoLTd2LThoN3YtN2g4djdoN3Y4eiIvPjwvc3ZnPg=='
                                text='Medizin'
                                stylingMode='text'
                                onClick={() => navigate('/athlete/medical-overview')  }
                            />
                        </Item>
                        <Item location='after' locateInMenu='auto'>
                            <div className='separator' />
                        </Item>
                        <Item name='exportButton' />
                        <Item location='after' locateInMenu='auto'>
                            <div className='separator' />
                        </Item>
                        <Item name='searchPanel' locateInMenu='auto' />
                    </Toolbar>
                    <Column
                        dataField='lastname'
                        caption='Name'
                        sortOrder='asc'
                        hidingPriority={5}
                        minWidth={150}
                        cellRender={cellNameRender}
                        dataType='string'
                    />
                    <Column
                        dataField='surname'
                        caption='Vorname'
                        visible={false}
                        dataType='string'
                    />
                    <Column dataField="dateofbirth" caption="Geburtstag" dataType="date" format="dd.MM.yyyy" hidingPriority={5} allowHiding={true} />
                    <Column dataField="gender" caption="Geschlecht" dataType='string' hidingPriority={4} allowHiding={true} lookup={{ dataSource: [{ value: 0, text: "männlich" }, { value: 1, text: "weiblich" }, { value: 2, text: "divers" }], valueExpr: 'value', displayExpr: 'text' }} />
                    <Column dataField="traininggroupId" caption="Trainingsgruppe" dataType='string' hidingPriority={2} allowHiding={true} lookup={{ dataSource: dataSourceTrainingGroup, valueExpr: 'traininggroupId', displayExpr: 'groupname' }} />
                    <Column dataField="clubId" caption="Verein" dataType='string' hidingPriority={3} allowHiding={true} lookup={{ dataSource: dataSourceClub, valueExpr: 'clubId', displayExpr: 'shortclubname' }} />
                    <Column dataField="dsvId" caption="DSV-ID" dataType='string' hidingPriority={1} allowHiding={true} />


                    <Column
                        dataField='status'
                        caption='Status'
                        dataType='string'
                        hidingPriority={3}
                        minWidth={100}
                        cellRender={AthleteStatus}
                        editCellRender={editCellStatusRender}

                    />


                </DataGrid>
                {/* <AthletePanel athleteId={athleteId} isOpened={isPanelOpened} changePanelOpened={changePanelOpened} changePanelPinned={changePanelPinned} /> */}
                <FormPopup title='Neuer Sportler' visible={popupVisible} setVisible={changePopupVisibility} onSave={onSaveClick}>
                    <AthleteNewForm initData={formDataDefaults} onDataChanged={onDataChanged} clubData={dataSourceClub} traininggroupData={dataSourceTrainingGroup}/>
                </FormPopup>
                <Popup
                    title='Sportler importieren'
                    visible={importPopupVisible}
                    width='95vw'
                    height='90vh'
                    showCloseButton
                    onHiding={() => setImportPopupVisible(false)}
                >
                    <div className='athlete-import'>
                        <div className='athlete-import-toolbar'>
                            <div>
                                {importRows.length
                                    ? `${importRows.length} Sportler in der Vorschau. Änderungen werden erst mit „Importieren“ übernommen.`
                                    : 'Wählen Sie eine CSV- oder Excel-Datei aus.'}
                            </div>
                            <Button
                                icon='upload'
                                text='Andere Datei auswählen'
                                stylingMode='outlined'
                                onClick={chooseImportFile}
                                disabled={isImportLoading}
                            />
                        </div>
                        <DataGrid
                            className='athlete-import-grid'
                            dataSource={importRows}
                            keyExpr='rowNumber'
                            showBorders
                            columnAutoWidth
                            height='100%'
                            onRowUpdated={onImportRowUpdated}
                        >
                            <Editing mode='cell' allowUpdating />
                            <Scrolling mode='standard' />
                            <Column dataField='rowNumber' caption='Dateizeile' width={85} allowEditing={false} />
                            <Column dataField='firstName' caption='Vorname' minWidth={130} />
                            <Column dataField='lastName' caption='Nachname' minWidth={130} />
                            <Column dataField='gender' caption='Geschlecht' width={120} lookup={{ dataSource: IMPORT_GENDERS, valueExpr: 'value', displayExpr: 'text' }} />
                            <Column dataField='dateOfBirth' caption='Geburtsdatum' dataType='date' format='dd.MM.yyyy' />
                            <Column dataField='dsvId' caption='DSV-ID' />
                            <Column dataField='medicalCertificate' caption='Ärztliches Attest' dataType='date' format='dd.MM.yyyy' />
                            <Column dataField='entryDate' caption='Eintrittsdatum' dataType='date' format='dd.MM.yyyy' />
                            <Column dataField='traininggroupId' caption='Trainingsgruppe' lookup={{ dataSource: dataSourceTrainingGroup, valueExpr: 'traininggroupId', displayExpr: 'groupname' }} />
                            <Column
                                dataField='clubId'
                                caption='Verein'
                                validationRules={[{ type: 'required', message: REQUIRED_CLUB_ERROR }]}
                                lookup={{
                                    dataSource: dataSourceImportClub,
                                    valueExpr: 'clubId',
                                    displayExpr: 'shortclubname'
                                }}
                            />
                            <Column dataField='license' caption='Lizenz' />
                            <Column dataField='exitDate' caption='Austrittsdatum' dataType='date' format='dd.MM.yyyy' />
                            <Column dataField='status' caption='Status' lookup={{ dataSource: ATHLETE_STATUS_LIST }} />
                            <Column dataField='nation1' caption='Nationalität 1' lookup={{ dataSource: NATIONS, valueExpr: 'id', displayExpr: 'text' }} />
                            <Column dataField='nation2' caption='Nationalität 2' lookup={{ dataSource: NATIONS, valueExpr: 'id', displayExpr: 'text' }} />
                            <Column dataField='nation3' caption='Nationalität 3' lookup={{ dataSource: NATIONS, valueExpr: 'id', displayExpr: 'text' }} />
                            <Column dataField='gradeLevel' caption='Klassenstufe' dataType='number' />
                            <Column
                                caption='Hinweise'
                                allowEditing={false}
                                minWidth={220}
                                cellRender={({ data }) => (
                                    <span className={data.errors?.length ? 'athlete-import-errors' : ''}>
                                        {data.errors?.join('; ')}
                                    </span>
                                )}
                            />
                        </DataGrid>
                    </div>
                    <ToolbarItem toolbar='bottom' location='after'>
                        <Button
                            text='Abbrechen'
                            stylingMode='outlined'
                            onClick={() => setImportPopupVisible(false)}
                            disabled={isImportLoading}
                        />
                    </ToolbarItem>
                    <ToolbarItem toolbar='bottom' location='after'>
                        <Button
                            text={isImportLoading ? 'Bitte warten…' : `${importRows.length} Sportler importieren`}
                            type='default'
                            stylingMode='contained'
                            onClick={submitImport}
                            disabled={isImportLoading || importRows.length === 0}
                        />
                    </ToolbarItem>
                </Popup>
            </div>
        </div>
    );
};
